import { render, staticRenderFns } from "./OrdersAlphaList.vue?vue&type=template&id=346b8528&scoped=true"
import script from "./OrdersAlphaList.vue?vue&type=script&lang=js"
export * from "./OrdersAlphaList.vue?vue&type=script&lang=js"
import style0 from "./OrdersAlphaList.vue?vue&type=style&index=0&id=346b8528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b8528",
  null
  
)

export default component.exports